// extracted by mini-css-extract-plugin
module.exports = {"cls3":"GreatHall_cls3__26LCZ","cls1":"GreatHall_cls1__3jPNL","cls2":"GreatHall_cls2__3f1w-"};